import { moduleProviderFactory } from 'core/providers';
import { WarehouseList, WarehouseEdit } from 'modules/warehouse/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.warehouse',
				pattern: '/warehouses',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.warehouse.list',
						pattern: '',
						component: WarehouseList,
						isPlatformRoute: true,
					},
					{
						name: 'master.app.main.warehouse.create',
						pattern: '/create',
						component: WarehouseEdit,
						isPlatformRoute: true,
					},
					{
						name: 'master.app.main.warehouse.edit',
						pattern: '/edit/:id',
						component: WarehouseEdit,
						isPlatformRoute: true,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/warehouse/config.js